<script lang="jsx">
import { mapGetters, mapActions } from 'vuex'
import { caseOf, map } from '../lib'

const SpinnerView = () => (
  <div class="spinner-container">
    <div class="spinner" />
  </div>
)

export default {
  data() {
    return {
      newComment: ''
    }
  },
  computed: {
    ...mapGetters('users', ['comments'])
  },
  created() {
    this.fetchComments()
  },
  methods: {
    ...mapActions('users', ['fetchComments', 'addComment']),
    setNewComment(newComment) {
      this.newComment = newComment;
    },
  },
  render() {
    return (
      <div>
        <h4>Comments:</h4>
        <form onSubmit={(e) => (e.preventDefault(), this.addComment(this.newComment))}>
          <textarea rows="1" cols="40" name="newCommentText" onInput={(e) => this.setNewComment(e.target.value)} class="addComment" />
          <button type="submit" class="success" disabled={this.newComment?.trim()?.length < 1}  >
            Add comment
          </button>
        </form>
        <table class="comments">
          <tbody>
            {caseOf(this.comments, {
              Some: (comments) => [
                map(comments, (comment) => (
                  <tr class="comment">
                    <td>{comment.created_at}</td>
                    <td>{comment.comment}</td>
                  </tr>
                )),
              ],
              None: () => <SpinnerView />,
            })}
          </tbody>
        </table>
      </div>
    )
  },
}
</script>
